import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { PwaController } from "@/components/PwaController";

import LandingPage from "@/pages/LandingPage";
import StaffLoginPage from "@/pages/StaffLoginPage";
import ClaimAccessPage from "@/pages/ClaimAccessPage";
import ForgotAccessCodePage from "@/pages/ForgotAccessCodePage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import ApplyPage from "@/pages/ApplyPage";
import OnboardInvitePage from "@/pages/OnboardInvitePage";
import PlatformStaffInvitePage from "@/pages/PlatformStaffInvitePage";
import RecordsDownloadPage from "@/pages/RecordsDownloadPage";
import RecordsPaymentSuccessPage from "@/pages/RecordsPaymentSuccessPage";

import { InmateRoutes } from "@/routes/InmateRoutes";
import { ProviderRoutes } from "@/routes/ProviderRoutes";
import { AdminRoutes } from "@/routes/AdminRoutes";
import { InstitutionRoutes } from "@/routes/InstitutionRoutes";
import FileViewerPage from "@/pages/FileViewerPage";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <PwaController />
                <Routes>
                    {/* Public */}
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/login" element={<StaffLoginPage />} />
                    <Route path="/claim-access" element={<ClaimAccessPage />} />
                    <Route path="/forgot-access-code" element={<ForgotAccessCodePage />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/apply" element={<ApplyPage />} />
                    <Route path="/onboard/:token" element={<OnboardInvitePage />} />
                    <Route path="/onboard/staff/:token" element={<PlatformStaffInvitePage />} />
                    <Route path="/records/download/:token" element={<RecordsDownloadPage />} />
                    <Route path="/records/pay/success" element={<RecordsPaymentSuccessPage />} />
                    <Route path="/records/pay/cancel" element={<RecordsPaymentSuccessPage />} />
                    <Route path="/file-viewer" element={<FileViewerPage />} />

                    {InmateRoutes()}
                    {ProviderRoutes()}
                    {AdminRoutes()}
                    {InstitutionRoutes()}

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </AuthProvider>
    );
}

export default App;
